import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 10,
    width: '100%',
    boxSizing: 'border-box',
  },
  filterSection: {
    width: '95%',
    marginBottom: 16,
    marginTop: 16,
  },
  filterForm: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
  },
  filterType: {
    minWidth: 240,
  },
  sessionIdOperator: {
    minWidth: 140,
  },
  filterValue: {
    flex: '1 1 260px',
    maxWidth: 420,
  },
  appliedFilters: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 12,
  },
  tableContainer: {
    width: '95%',
    overflowX: 'auto',
    boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
  },
  dataTable: {
    borderCollapse: 'collapse',
    backgroundColor: '#FFFFFF',
    width: '100%',
    minWidth: 1000,
    tableLayout: 'fixed',
    '& th': {
      padding: '8px 6px',
      textAlign: 'center',
      fontSize: '1rem',
      textTransform: 'uppercase',
      backgroundColor: theme.palette.grey[800],
      color: '#FFFFFF',
    },
    '& th:nth-child(1)': { width: 150 },
    '& th:nth-child(2)': { width: 130 },
    '& th:nth-child(3)': { width: 90 },
    '& th:nth-child(4)': { width: 80 },
    '& th:nth-child(5)': { width: 250 },
    '& th:nth-child(6)': { width: 200 },
    '& th:nth-child(7)': { width: 100 },
    '& th:nth-child(8)': { width: 110 },
    '& th:nth-child(9)': { width: 120 },
    '& th:nth-child(10)': { width: 80 },
    '& th:nth-child(11)': { width: 60 },
    '& tbody tr': {
      height: 48,
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
      '&:nth-child(even)': { backgroundColor: '#EFEFEF' },
      '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.08)' },
    },
    '& td': {
      padding: '6px 8px',
      textAlign: 'center',
      fontSize: '1.15rem',
      overflowWrap: 'anywhere',
    },
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 20,
    minHeight: '70vh',
  },
  emptyTable: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
  },
}))
